export interface HashMap {
  [key: string]: string | number;
}

export type CustomLink = {
  name: string;
  link: string;
  target?: string;
  as?: 'a' | 'Link';
  onClick?: (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>) => void;
};

interface Website {
  websiteID: number;
  websiteName: string;
}

interface MonthlyItemType {
  monthlyItemTypeID: number;
  monthlyItemTypeDescription: string;
}

export interface MonthlyItem {
  monthlyItemID: number;
  website: Website;
  monthlyItemType: MonthlyItemType;
  startDate: string;
  endDate: string;
  displayOrder: number;
  mobileImageURL: string;
  tabletImageURL: string;
  desktopImageURL: string;
  link: string;
  pdfName: string;
}

export type ImageFormats = {
  ext: string;
  url: string;
  hash: string;
  mime: string;
  name: string;
  path: string | null;
  size: number;
  width: number;
  height: number;
};

export type ImageType = {
  id: number;
  name: string;
  alternativeText: string | null;
  caption: string | null;
  width: number;
  height: number;
  formats: {
    large?: ImageFormats;
    small?: ImageFormats;
    medium?: ImageFormats;
    thumbnail?: ImageFormats;
  };
  hash: string;
  ext: string;
  mime: string;
  size: number;
  url: string;
  previewUrl: string | null;
  provider: string;
  provider_metadata: any;
  folderPath: string;
  createdAt: string;
  updatedAt: string;
};

export const NextCacheTags = {
  META: 'meta-data',
  CATEGORIES: 'categories',
  PRODUCTS: 'products',
  INGREDIENTS: 'ingredients',
  ALL: '*',
  BANNERS: 'banners',
  PRODUCT: (slug: string | number) => `products_${slug}`,
  CATEGORY: (slug: string | number) => `category_${slug}`,
} as const;

export interface TopHeaderTextRepsonse {
  visible: boolean;
  startDate: string;
  endDate: string;
  value: {
    name: string;
    value: {
      value: string;
      loaded: boolean;
      visible: boolean;
    };
  };
  default: {
    name: string;
    value: {
      value: string;
      loaded: boolean;
      visible: boolean;
    };
  };
}

export interface SocialLink {
  id: string;
  icon: string;
  link: string;
  visible: boolean;
  platform: string;
}

export type ResponseSocialLinks = SocialLink[];
export type FormErrorList = Record<string, string>;

export const GOOGLE = 'google';
export const FACEBOOK = 'facebook';
export const APPLE = 'apple';
